import React, { useMemo } from 'react'
const DEFAULT_ICON_SIZE = 24

export interface IconProps {
    color?: string
    altColor?: string
    size?: number
    className?: string
}

export interface IconWrapperProps extends IconProps {
    renderIcon: (color: string, altColor?: string) => React.JSX.Element
    viewBox?: `${number} ${number} ${number} ${number}`
}

export const IconWrapper: React.FC<IconWrapperProps> = ({
    color = 'currentColor',
    size = DEFAULT_ICON_SIZE,
    renderIcon,
    className,
    altColor,
    viewBox = '0 0 24 24'
}) => {
    const icon = useMemo(() => renderIcon(color, altColor), [color, altColor])
    return (
        <svg className={className} width={size} height={size} viewBox={viewBox} fill='none'>
            {icon}
        </svg>
    )
}
